// --------------------------------------------------------------------------
// propertyMap.js
// --------------------------------------------------------------------------
// Uses Google Maps API to create map with property locations
// --------------------------------------------------------------------------

EC.propertyMap = function () {

    'use strict';

    let map;
    let infoWindows;
    let pins;
    let iconUrl;
    let activeIconUrl;

    function init () {
        infoWindows = [];
        pins = [];
        iconUrl = '/resources/images/interface/accommodation-pin.svg';
        activeIconUrl = '/resources/images/interface/accommodation-pin-active.svg';
        if ($(window).width() > 759 ){
            initMap();
            propertyData.map(addPropertyMarker);
        }
    }

    function initMap () {
        const $mapEl = $('#js-property-map');
        const zoom = parseInt($mapEl.data('zoom'), 10) || 15;
        map = new google.maps.Map($mapEl[0], {
            center: new google.maps.LatLng(53.995776, -1.534502),
            zoom: zoom,
            scrollwheel: false,
            styles: [
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "lightness": 100
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#C6E2FF"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#C5E3BF"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#D1D1B8"
                        }
                    ]
                }
            ]
        });
    }

    function addPropertyMarker (property) {
        var pin = new google.maps.Marker({
            map: map,
            position: new google.maps.LatLng(parseFloat(property.lat), parseFloat(property.long)),
            optimized: false,
            icon: {
                url: iconUrl,
                scaledSize: new google.maps.Size(22, 31)
            }
        });

        pins.push(pin);

        createInfoWindow(property, pin);
        pin.addListener('click', function() {
            EC.propertiesView.updateSelected(property);
            pins.map(pin => pin.setIcon({
                url: iconUrl,
                scaledSize: new google.maps.Size(22, 31)
            }));
            pin.setIcon({
                url: activeIconUrl,
                scaledSize: new google.maps.Size(22, 31)
            });
        });
    }

    function createInfoWindow (info, pin) {
        var infoWindow = new google.maps.InfoWindow({
            content: createWindowMarkup(info)
        });

        infoWindows.push(infoWindow);

        pin.addListener('click', function(){
            infoWindows.map(window => window.close());
            infoWindow.open(map, pin);
        });
    } 

    function createWindowMarkup (property){
        return `<h4 class="e-property-popup__heading">${property.name}</h4>`;
    }

    return {
        init: init
    };

}();